module.exports = __webpack_public_path__ + "static/media/loading.071ec8a1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/loading.gif
// module id = 496
// module chunks = 0